import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketplaceStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Package',
      label: 'Aktif İlan',
      value: stats?.activeListings,
      color: 'text-primary bg-primary/10'
    },
    {
      icon: 'Users',
      label: 'Toplam Satıcı',
      value: stats?.totalSellers,
      color: 'text-secondary bg-secondary/10'
    },
    {
      icon: 'TrendingUp',
      label: 'Bu Hafta',
      value: `+${stats?.newThisWeek}`,
      color: 'text-success bg-success/10'
    },
    {
      icon: 'MessageCircle',
      label: 'Mesajlaşma',
      value: stats?.activeChats,
      color: 'text-accent bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-4 md:p-5 shadow-organic border border-border hover:shadow-organic-lg transition-smooth"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 rounded-lg ${item?.color} flex items-center justify-center flex-shrink-0`}>
              <Icon name={item?.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-2xl md:text-3xl font-bold text-foreground">{item?.value}</p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">{item?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default MarketplaceStats;